@if (!href) {
    <a>
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
} @else {
    <a [href]="href" [vnSpeculativeLink]="href">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>
}

<ng-template #itemTemplate>
    <ds-list-item
        class="list-item-alignment"
        [title]="title || ''"
        [subtitle]="subTitle || ''"
        [selected]="isActive"
        [boldTitle]="boldTitle"
        (click)="clicked()">
        @if (showStartSlot) {
            <span slot="start">
                @if (icon) {
                    <vn-icon class="icon-alignment" [name]="icon" [size]="iconSize || ''" />
                }
                <ng-content select="[item-icon]"></ng-content>
            </span>
        }

        <div class="list-item-end" slot="end">
            <ng-content select="[competition-logo]"></ng-content>
            @if (badge) {
                <ng-content select="[badge]"></ng-content>
            }
            @if (!title) {
                <ng-content select="[item-title]"></ng-content>
            }
            @if (count) {
                <ds-notification-bubble variant="neutral" size="medium">
                    {{ count }}
                </ds-notification-bubble>
            }
            @if (arrow) {
                <vn-icon class="arrow-icon" name="theme-right" size="16" />
            }
        </div>
    </ds-list-item>
    <ng-content select="[vertical-divider]"></ng-content>
</ng-template>
@if (isShowBorder) {
    <ds-divider />
}
